<template>
    <div class="saas-page linear-admin-workflow">
        <div class="saas-hero card-saas linear-page-hero">
            <div class="saas-hero__main">
                <p class="saas-hero__crumb">
                    <router-link to="/home">{{ trans('general.home') }}</router-link>
                    <span class="px-1">/</span>
                    <router-link to="/email-template">{{ trans('template.template') }}</router-link>
                    <span class="px-1">/</span>
                    <span>{{trans('template.edit_template')}}</span>
                </p>
                <h1 class="saas-hero__title">{{trans('template.edit_template')}}</h1>
                <p class="linear-page-copy">{{trans('template.available_fields')}}: {{fields}}</p>
            </div>
        </div>
        <div class="card-saas linear-admin-panel">
            <form class="linear-admin-form" @submit.prevent="submit" @keydown="templateForm.errors.clear($event.target.name)">
                <div class="form-group">
                    <label for="">{{trans('template.subject')}}</label>
                    <input class="form-control" type="text" value="" v-model="templateForm.subject" name="subject" :placeholder="trans('template.subject')">
                    <show-error :form-name="templateForm" prop-name="subject"></show-error>
                </div>
                <div class="form-group">
                    <html-editor name="body" :model.sync="templateForm.body" isUpdate="true" @clearErrors="templateForm.errors.clear('body')"></html-editor>
                    <show-error :form-name="templateForm" prop-name="body"></show-error>
                </div>
                <div class="d-flex flex-wrap gap-2 justify-content-end mt-3">
                    <router-link to="/email-template" class="btn btn-sm admin-form-btn-cancel">{{trans('general.cancel')}}</router-link>
                    <button type="submit" class="btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid">{{trans('general.save')}}</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import htmlEditor from '../../components/html-editor'

    export default {
        components : { htmlEditor },
        data() {
            return {
                id:this.$route.params.id,
                templateForm: new Form({
                    subject: '',
                    body: '',
                }),
                fields: ''
            }
        },
        mounted(){
            if(!helper.hasPermission('access-configuration')){
                helper.notAccessibleMsg();
                this.$router.push('/home');
            }

            if(!helper.featureAvailable('email_template')){
                helper.featureNotAvailableMsg();
                this.$router.push('/home');
            }

            axios.get('/api/email-template/'+this.id)
                .then(response => response.data)
                .then(response => {
                    this.templateForm.subject = response.email_template.subject;
                    this.templateForm.body = response.email_template.body;
                    this.fields = response.fields;
                })
                .catch(error => {
                    helper.showDataErrorMsg(error);
                    this.$router.push('/email-template');
                })
        },
        methods: {
            submit(){
                this.templateForm.patch('/api/email-template/'+this.id)
                    .then(response => {
                        toastr.success(response.message);
                        this.$router.push('/email-template');
                    })
                    .catch(error => {
                        helper.showErrorMsg(error);
                    });
            }
        }
    }
</script>

<style scoped>
.linear-page-hero {
    align-items: center;
}

.linear-eyebrow,
.linear-section-head span,
.linear-fields-note span {
    color: #635bff;
    font-size: 0.6875rem;
    font-weight: 800;
    letter-spacing: 0.08em;
    text-transform: uppercase;
}

.linear-page-copy {
    margin: 0.45rem 0 0;
    color: #64748b;
    font-size: 0.875rem;
}

.linear-admin-panel {
    padding: 1.15rem;
}

.linear-section-head {
    margin-bottom: 1rem;
}

.linear-section-head h4 {
    margin: 0.25rem 0 0;
    color: #0f172a;
    font-size: 1rem;
    font-weight: 800;
    letter-spacing: -0.03em;
}

.linear-admin-form label {
    color: #475569;
    font-size: 0.75rem;
    font-weight: 800;
    letter-spacing: 0.04em;
    text-transform: uppercase;
}

.linear-admin-form .form-control {
    border-color: #e2e8f0;
    border-radius: 10px;
}

.linear-fields-note {
    display: grid;
    gap: 0.35rem;
    margin-bottom: 1rem;
    padding: 0.875rem 1rem;
    border: 1px solid #e2e8f0;
    border-radius: 14px;
    background: #f8fafc;
}

.linear-fields-note strong {
    color: #334155;
    font-size: 0.875rem;
    line-height: 1.5;
}

@media (max-width: 575.98px) {
    .linear-page-hero {
        align-items: flex-start;
    }
}
</style>
